import {
  AppBar,
  Box,
  Button,
  Grid,
  TextField,
  Toolbar,
  Typography,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import SendIcon from '@material-ui/icons/SendRounded';
import AttachFile from '@material-ui/icons/AttachFileRounded';
import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../../Components/BreadCrumb';
import { Link, useHistory } from 'react-router-dom';
import routes from '../../../../Utils/routes.json';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import EditOutlined from '@material-ui/icons/EditOutlined';
import { useEffect, useState } from 'react';
import KenCard from '../../../../global_components/KenCard';
import KenGrid from '../../../../global_components/KenGrid';
import KenPopover from '../../../../Components/KenPopOver';
import KenDialogBox from '../../../../global_components/KenDialogBox';
import KenSelectWrap from '../../../../global_components/KenSelect';
import {
  RiFilterLine,
  RiCheckFill,
  RiNotification2Fill,
  RiNotification3Line,
} from 'react-icons/ri';
import Kentable from '../../../../global_components/KenTable/kentable';
import { Message } from '@material-ui/icons';
import KenDateTimePicker from '../../../../global_components/KenDateTimePicker';
import KenSelect from '../../../../global_components/KenSelect';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
// Icons
import EditIcon from '@material-ui/icons/EditOutlined';
import DoneIcon from '@material-ui/icons/DoneAllTwoTone';
import RevertIcon from '@material-ui/icons/NotInterestedOutlined';

import '../../../../style/index.css';
import {
  getInvigilator_s1_Data,
  postInvigilator_s1_Data,
} from '../../../../Utils/apiServices';
import moment from 'moment';
const arrayBreadCrumb = [
  // { head: 'ADMIN PORTAL', url: routes.adminManagement },
  {
    head: 'EXAM',
    url: routes.exam,
  },
  {
    head: 'INVIGILATION AND PROCTORING',
  },
];
export const facultyDropDown = [
  {
    label: 'Choose Room No',
    value: '--Select--',
  },
  {
    label: 'Room No. 101',
    value: 'Room No. 101',
  },
  {
    label: 'Room No. 102',
    value: 'Room No. 102',
  },
  {
    label: 'Room No. 103',
    value: 'Room No. 103',
  },
  {
    label: 'Room No. 104',
    value: 'Room No. 104',
  },
];

let abcds;
const ActionCellSendMessage = (row) => {
  const classes = useStyles();

  // Message Modal
  const [messageDialog, setMessageDialog] = useState(false);

  function handleMessageDialog() {
    setMessageDialog((prevState) => !prevState);
  }
  const { id } = row.row.values;

  const handleClick = () => {
    handleMessageDialog();
  };
  return (
    <>
      <Message
        style={{
          color: '#092682',
        }}
        className="m-0"
        onClick={handleClick}
      />
      {/* Message Modal */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Message Modal
          </Typography>
        }
        open={messageDialog}
        handleClose={() => handleMessageDialog()}
        negativeButtonClick={() => handleMessageDialog()}
        positiveButtonClick={() => handleMessageDialog()}
        positiveButtonText="Send"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          {id}
        </Grid>
      </KenDialogBox>
    </>
  );
};
const editHandler = (id) => {
  console.log('Editing started', id);
};
const onToggleEditMode = (id) => {
  console.log('id', id);
};
const ActionCellEdit = (row, isUpdating) => {
  const { id } = row.row.values;
  return <EditOutlined className="m-0" onClick={() => onToggleEditMode(id)} />;
};

const CellWithButton = (row) => {
  const classes = useStyles();
  const { seating_plan, id } = row.row.values;

  // console.log({ eligibility_status });

  let classOfBtn;
  if (seating_plan === 'Generate') {
    classOfBtn = classes.Green;
  } else if (seating_plan === 'View / Edit') {
    classOfBtn = classes.Blue;
  } else {
    classOfBtn = classes.medium;
  }
  if (seating_plan === 'Generate') {
    return (
      <>
        <Box>
          <div style={{ display: 'flex' }}>
            <Button
              variant="primary"
              component={Link}
              className={classOfBtn}
              to={`${routes.seatingPlan}/arrangement/${id}`}
            >
              Generate
            </Button>
            <Button
              variant="primary"
              component={Link}
              className={classes.publishGenerate}
              // to={`${routes.currentProgrammes}/${id}/details`}
            >
              Publish
            </Button>
          </div>
        </Box>
      </>
    );
  } else {
    return (
      <>
        <Box>
          <div style={{ display: 'flex' }}>
            <Button
              variant="primary"
              component={Link}
              className={classes.Blue}
              // to={`${routes.currentProgrammes}/${id}/details`}
            >
              View / Edit
            </Button>
            <Button
              variant="primary"
              component={Link}
              className={classes.publishView}
              // to={`${routes.currentProgrammes}/${id}/details`}
            >
              Publish
            </Button>
          </div>
        </Box>
      </>
    );
  }
};

const UserCell = (row, name) => {
  return (
    <p>
      <img
        style={{ borderRadius: '50%', marginRight: '10px' }}
        width="40"
        height="40"
        src={row}
        alt="user"
      />
      {name}
    </p>
  );
};

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  subHeaderTitle: {
    width: '100%',
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    color: '#FFFFFF',
    background: '#EB5757',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  normal: {
    color: '#02ab4a',

    background: 'rgba(138, 245, 196,0.4)',

    borderRadius: '20px',
    fontSize: '10px',
    height: '25px',

    margin: '5px 5px',
    '&:hover': {
      background: 'rgba(138, 245, 196,0.4)',

      color: '#02ab4a',
    },
    // color: '#FFFFFF',
    // background: '#27AE60',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '102px',
  },
  publishGenerate: {
    color: '#505F79',
    background: 'rgba(196, 196, 196,0.2)',
    borderRadius: '20px',
    fontSize: '10px',
    margin: '5px 5px',
    height: '25px',

    '&:hover': {
      background: 'rgba(196, 196, 196,0.2)',
      color: '#505F79',
    },
    // color: '#FFFFFF',
    // background: '#979797',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '102px',
  },
  publishView: {
    color: '#f17100',
    background: 'rgba(255, 196, 10,0.2)',
    borderRadius: '20px',
    fontSize: '10px',
    margin: '5px 5px',
    height: '25px',

    '&:hover': {
      background: 'rgba(255, 196, 10,0.2)',
      color: '#f17100',
    },
    // color: '#FFFFFF',
    // background: '#F2994A',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '102px',
  },
  Blue: {
    color: '#00218D',

    background: 'rgba(0, 33, 141,0.2)',

    borderRadius: '20px',
    fontSize: '10px',
    height: '25px',

    margin: '5px 5px',
    '&:hover': {
      background: 'rgba(0, 33, 141,0.2)',

      color: '#00218D',
    },
    // color: '#FFFF',
    // background: '#03248F',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '102px',
  },
  Green: {
    color: '#FFFF',
    background: '#27AE60',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  medium: {
    color: '#FFFFFF',
    background: '#F2994A',
    width: '102px',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
}));

const selectOptionsCampus = [
  {
    label: 'Select Course',
    value: '',
  },
  {
    label: 'BBAFIN309-International Finance',
    value: 'BBAFIN309-International Finance',
  },
  {
    label: 'BBAECO103-Macroeconomics',
    value: 'BBAECO103-Macroeconomics',
  },
  {
    label: 'BBALIB106-World Cultures',
    value: 'BBALIB106-World Cultures',
  },
  {
    label: 'MGBBUS203-Global Adaptability 2',
    value: 'MGBBUS203-Global Adaptability 2',
  },
  {
    label: 'MBAGACC213-Financial Statement Analysis',
    value: 'MBAGACC213-Financial Statement Analysis',
  },
  {
    label: 'MBAGITM213-Managing Technology Projects and Outsourcing',
    value: 'MBAGITM213-Managing Technology Projects and Outsourcing',
  },
  {
    label: 'MBAGITM213-Managing Technology Projects and Outsourcing',
    value: 'MBAGITM213-Managing Technology Projects and Outsourcing',
  },
  {
    label: 'MBAGACC214-Management Accounting and Control',
    value: 'MBAGACC214-Management Accounting and Control',
  },
];

const selectOptionsProgram = [
  {
    label: 'Select Batch',
    value: '--Select--',
  },
  {
    label: 'Batch 1',
    value: '1',
  },
  {
    label: 'Batch 2',
    value: '2',
  },
];

const selectOptionsSubject = [
  {
    label: 'Select Subject',
    value: '--Select--',
  },
  {
    label: 'Subject 1',
    value: '1',
  },
  {
    label: 'Subject 2',
    value: '2',
  },
];

const selectOptionsTerm = [
  {
    label: 'Select Date',
    value: '--Select--',
  },
  {
    label: 'Date 1',
    value: '1',
  },
  {
    label: 'Date 2',
    value: '2',
  },
];

const selectOptionsDuration = [
  {
    label: 'Select Duration',
    value: '',
  },
  {
    label: '1',
    value: '1',
  },
  {
    label: '2',
    value: '2',
  },
  {
    label: '3',
    value: '3',
  },
  {
    label: '4',
    value: '4',
  },
  {
    label: '5',
    value: '5',
  },
  {
    label: '6',
    value: '6',
  },
  {
    label: '7',
    value: '7',
  },
  {
    label: '8',
    value: '8',
  },
  {
    label: '9',
    value: '9',
  },
];
const selectOptionsBatch = [
  {
    label: 'Select Exam Type',
    value: '',
  },
  {
    label: 'Online',
    value: 'Online',
  },
  {
    label: 'Ofline',
    value: 'Ofline',
  },
];

const UserCellBulkMessage = (row, name) => {
  return (
    <p>
      <img
        style={{ borderRadius: '50%' }}
        width="40"
        height="40"
        src={row}
        alt="user"
      />
      {name}
    </p>
  );
};

const sendBulkDataGrid = [
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Raleigh Avieson'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Fleur Fowler'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Nealy Leitch'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Carolyne Angrock'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Abeu Aiers'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Penny Scrivinor'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Grier Laverick'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Dur Leile'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Claudine Owenson'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Stefa True'
    ),
  },
];
const CustomTableCell = ({ row, name, onChange }) => {
  const classes = useStyles();
  const { isEditMode } = row;
  return (
    <TableCell align="left" className={classes.tableCell}>
      {isEditMode ? (
        <Input
          value={row[name]}
          name={name}
          onChange={(e) => onChange(e, row)}
          className={classes.input}
        />
      ) : (
        row[name]
      )}
    </TableCell>
  );
};
const CustomTableCellForDropDown = ({ row, name, onChange }) => {
  const { isEditMode } = row;
  console.log('row', row[name]);
  if (
    row[name] === 'Generate' ||
    row[name] === 'Room No. 101' ||
    row[name] === 'Room No. 102' ||
    row[name] === 'Room No. 103' ||
    row[name] === 'Room No. 104' ||
    row[name] === '--Select--'
  ) {
    return (
      <TableCell align="left">
        {isEditMode ? (
          <Box>
            <KenSelect
              name={name}
              options={facultyDropDown}
              value={row[name]}
              dropdownColor="#ffffff"
              onChange={(e) => onChange(e, row)}
              required={true}
            />
          </Box>
        ) : (
          row[name]
        )}
      </TableCell>
    );
  } else {
    return (
      <TableCell align="left">
        {isEditMode ? (
          <Box>
            <Input
              value={row[name]}
              name={name}
              onChange={(e) => onChange(e, row)}
              // className={classes.input}
            />
          </Box>
        ) : (
          <a href="#">{row[name]}</a>
        )}
      </TableCell>
    );
  }
};
const CustomTableCellForDate = ({ row, name, onChange }) => {
  const classes = useStyles();
  const { isEditMode } = row;
  return (
    <TableCell align="left" className={classes.tableCell}>
      {isEditMode ? (
        <KenDateTimePicker
          name={name}
          label="Start Date"
          inputBaseRootClass={classes.kenDateTimePickerColor}
          placeholder="Start Date"
          value={row[name]}
          type="date"
          required={true}
          // defaultValue={startDate}
          onChange={(e) => onChange(e, row)}
        />
      ) : (
        row[name]
      )}
    </TableCell>
  );
};
const CustomTableCellForTime = ({ row, name, onChange }) => {
  const classes = useStyles();
  const { isEditMode } = row;
  return (
    <TableCell align="left" className={classes.tableCell}>
      {isEditMode ? (
        <KenDateTimePicker
          name={name}
          label="Start Time"
          inputBaseRootClass={classes.kenDateTimePickerColor}
          placeholder="Start Time"
          value={row[name]}
          type="time"
          required={true}
          // defaultValue={startTime}
          onChange={(e) => onChange(e, row)}
        />
      ) : (
        row[name]
      )}
    </TableCell>
  );
};
const Invigilation = () => {
  const [startDate, setStartDate] = useState('25-02-2022');
  const [Id, setId] = useState();
  const [startTime, setStartTime] = useState();
  const [previous, setPrevious] = useState({});
  const [linkState, setLinkState] = useState('Link');
  const [endDate, setEndDate] = useState('');
  const history = useHistory();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [facultyDrop, setFacultyDrop] = useState({});
  const [selectValueDuration, setSelectValueDuration] = useState(
    selectOptionsDuration[0].value
  );

  const onToggleEditMode = (check, id) => {
    console.log('ididididididid', id);
    setId(id);
    setRows((state) => {
      return rows.map((row) => {
        console.log('rowsssssssssssssssssssssss', row);
        if (row.id === id) {
          if (check === 'edit') {
            return { ...row, isEditMode: !row.isEditMode };
          }
          if (check === 'save') {
            const payload = [
              {
                id: row.id,
                dateOfExam: row.carbs,
                timeOfExam: row.protein,
                duration: parseInt(row.duration),
                examType: row.exam_type,
                venue: row.venue_link,
              },
            ];

            console.log('payloadpayloadpayloadpayload', payload);
            postInvigilator_s1_Data(payload)
              .then((res) => {
                console.log('res', res);
                getInvigilator_s1_DataListing();
              })
              .catch((err) => {
                console.log('errerrerrerrerrerr', err);
                alert('Failed to add. Please try again.');
              });
          }
        }
        return row;
      });
    });
  };
  const onToggleEdit = (id, rowes) => {
    setRows((state) => {
      return rowes.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };
  const onRevert = (id) => {
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return previous[id] ? previous[id] : row;
      }
      return row;
    });
    setRows(newRows);
    setPrevious((state) => {
      delete state[id];
      return state;
    });
    onToggleEdit(id, newRows);
  };
  const onChange = (e, row) => {
    console.log('data', row.id, rows, e.target.value, e.target.name);
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setRows(newRows);
  };

  const createData = (
    name,
    calories,
    term,
    carbs,
    protein,
    duration,
    exam_type,
    venue_link,
    button
  ) => ({
    id: name.replace(' ', '_'),
    name,
    calories,
    term,
    carbs,
    protein,
    duration,
    exam_type,
    venue_link,
    isEditMode: false,
    button,
  });
  const [rows, setRows] = useState([]);
  const [selectValueCampus, setSelectValueCampus] = useState(
    selectOptionsCampus[0].value
  );
  const handleSelectChangeCampus = (e) => {
    setSelectValueCampus(e.target.value);
  };

  const [selectValueProgram, setSelectValueProgram] = useState(
    selectOptionsProgram[0].value
  );
  const handleSelectChangeProgram = (e) => {
    setSelectValueProgram(e.target.value);
  };

  const [selectValueSubject, setSelectValueSubject] = useState(
    selectOptionsSubject[0].value
  );
  const handleSelectChangeSubject = (e) => {
    setSelectValueSubject(e.target.value);
  };

  const [selectValueTerm, setSelectValueTerm] = useState(
    selectOptionsTerm[0].value
  );
  const handleSelectChangeTerm = (e) => {
    setSelectValueTerm(e.target.value);
  };

  const [selectValueBatch, setSelectValueBatch] = useState(
    selectOptionsBatch[0].value
  );

  const handleSelectChangeBatch = (e) => {
    setSelectValueBatch(e.target.value);
  };

  const handleSelectChangeDuration = (e) => {
    setSelectValueDuration(e.target.value);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [filterDialog, setFilterDialog] = useState(false);

  function handleFilterDialog() {
    setFilterDialog((prevState) => !prevState);
  }

  const [sendBulkMessageDialog, setSendBulkMessageDialog] = useState(false);

  function handleSendBulkMessageDialog() {
    setSendBulkMessageDialog((prevState) => !prevState);
  }

  const [selectAllData, setSelectAllData] = useState(false);

  const handleSelectRow = (evt, row, index) => {
    // TODO code here to perform actions on selecting row in table
  };

  const handleSelectAllRows = (state) => {
    // TODO code here to perform actions on selecting all rows in table
    setSelectAllData(state);
  };

  const manageStartDate = (e, row) => {
    setEndDate(e.target.value);
  };

  const manageStartTime = (e, row) => {
    setStartTime(e.target.value);
  };
  const venueCell = (row) => {
    // const { num } = row.row.values;
    return (
      <Box>
        <KenSelect
          name="faculty"
          options={facultyDropDown}
          value={facultyDrop.faculty}
          dropdownColor="#ffffff"
          onChange={(e, row) =>
            setFacultyDrop({
              ...facultyDrop,
              [e.target.name]: e.target.value,
            })
          }
          required={true}
        />
      </Box>
    );
  };

  // Editing
  // const [dataOfTable, setDataOfTable] = useState(data);
  const [isEditing, setIsEditing] = useState(false);

  const onDataSave = (id) => {
    console.log('idsssssssssssssssssssssssssssssss', id);

    const newData = [...rows];
    return newData.map((row) => {
      if (row.id === id) {
        const payload = [
          {
            id: row.id,
            dateOfExam: row.carbs,
            timeOfExam: row.protein,
            duration: parseInt(row.duration),
            examType: row.exam_type,
            venue: row.venue_link,
          },
        ];

        console.log('payloadpayloadpayloadpayload', payload);
        postInvigilator_s1_Data(payload)
          .then((res) => {
            console.log('res', res);
            getInvigilator_s1_DataListing();
          })
          .catch((err) => {
            console.log('errerrerrerrerrerr', err);
            alert('Failed to add. Please try again.');
          });
      }
    });
  };

  const [courseOptions, setCourseOptions] = useState();
  const [termOptions, setTermOptions] = useState();
  const [dateOptions, setDateOptions] = useState();
  const [durationOptions, setDurationOptions] = useState();
  const [examTypeOptions, setExamTypeOptions] = useState();

  const filterOptions = (data, type) => {
    switch (type) {
      case 'course':
        let courseOP = [
          {
            label: 'Select Course',
            value: '--Select--',
          },
        ];
        const uniqueCourseOP = [...new Set(data.map((item) => item?.course))];
        uniqueCourseOP.forEach((el) => courseOP.push({ label: el, value: el }));
        return courseOP;
      case 'term':
        let termOP = [
          {
            label: 'Select Term',
            value: '--Select--',
          },
        ];
        const uniqueTermOP = [...new Set(data.map((item) => item?.term))];
        uniqueTermOP.forEach((el) => termOP.push({ label: el, value: el }));
        return termOP;
      case 'duration':
        let durationOP = [
          {
            label: 'Select Duration',
            value: '--Select--',
          },
        ];
        const uniqueDurationOP = [
          ...new Set(data.map((item) => item?.duration)),
        ];
        uniqueDurationOP.forEach((el) =>
          durationOP.push({ label: el, value: el })
        );
        return durationOP;
      case 'exam':
        let examTypeOP = [
          {
            label: 'Select Exam Type',
            value: '--Select--',
          },
        ];
        const uniqueExamTypeOP = [
          ...new Set(data.map((item) => item?.exam_type)),
        ];
        uniqueExamTypeOP.forEach((el) =>
          examTypeOP.push({ label: el, value: el })
        );
        return examTypeOP;
      default:
        break;
    }
  };

  const getInvigilator_s1_DataListing = () => {
    let filterData = {
      course: selectValueCampus,
      date: endDate,
      duration: selectValueDuration,
      examType: selectValueBatch,
      // subjectFaculty: selectValueFaculty,
      // allocatedTo: selectValueAlloctedFaculty,
    };
    getInvigilator_s1_Data(filterData).then((res) => {
      console.log('resForStudentStatus', res);
      const EvaluationDetailsInfo =
        res === null
          ? []
          : res.map((item, index) => {
              console.log('itemitem', item);
              return {
                button: 'assign',
                id: item.id,
                carbs: item.dateOfExam ? item.dateOfExam : '',
                terms: item.term ? item.term : '',
                duration: item.duration ? item.duration : '',
                exam_type: item.examType ? item.examType : '',
                isEditMode: false,
                name: item.course ? item.course : '',
                protein: item.startTimeOfExam ? item.startTimeOfExam : '',
                venue_link: item.venue ? item.venue : '',
              };
            });

      setRows(EvaluationDetailsInfo);
      setFilterDialog(false);
    });
  };

  useEffect(() => {
    getInvigilator_s1_DataListing();
    // setCourseOptions(filterOptions(rows, 'course'));
    // setTermOptions(filterOptions(rows, 'term'));
    // setDurationOptions(filterOptions(rows, 'duration'));
    // setExamTypeOptions(filterOptions(rows, 'exam'));
  }, []);

  abcds = Id;

  return (
    <Box>
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            Invigilation and proctoring
          </Typography>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            {/* <Button
              startIcon={<RiNotification3Line />}
              variant="contained"
              component={Link}
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
              to={`${routes.invigilationProctoringNotification}`}
            >
              Notification
            </Button> */}
            <Button
              startIcon={<RiFilterLine />}
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
              onClick={handleFilterDialog}
            >
              Filter
            </Button>
            {/* <Button
              variant="contained"
              color="primary"
              className={classes.addButton}
              style={{ marginRight: '15px' }}
              onClick={() => onDataSave(Id)}
            >
              Save
            </Button> */}
          </Grid>
        </Toolbar>
      </AppBar>

      <Box className={`cardlsitbox`}>
        <KenCard elevation={0}>
          <Table className={classes.table} aria-label="caption table">
            <TableHead>
              <TableRow>
                <TableCell className="tableHeaderTitle" align="left">
                  COURSE
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  TERMS
                </TableCell>
                <TableCell
                  className="tableHeaderTitle"
                  align="left"
                ></TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  DATE
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  START TIME
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  DURATION
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  EXAM TYPE
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  VENUE/LINK
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  EDIT
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  INVIGILATOR ASSIGNMENT
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => {
                const data = {
                  carbs: moment(row.carbs).format('YYYY-MM-DD'),
                };
                return (
                  <TableRow className="editableTableRowData" key={row.id}>
                    {console.log('rowrowrowrowrow', row)}

                    {/* <CustomTableCell {...{ row, name: 'name', onChange }} /> */}
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.terms}</TableCell>

                    <TableCell>{row.calories}</TableCell>

                    {/* <TableCell>{row.fat}</TableCell> */}
                    <CustomTableCellForDate
                      {...{ row, name: 'carbs', onChange }}
                    />
                    <CustomTableCellForTime
                      {...{ row, name: 'protein', onChange }}
                    />
                    <CustomTableCell {...{ row, name: 'duration', onChange }} />
                    <CustomTableCell
                      {...{ row, name: 'exam_type', onChange }}
                    />
                    <CustomTableCellForDropDown
                      className="editableTableRowData"
                      {...{ row, name: 'venue_link', onChange }}
                    />
                    {/* <TableCell className={classes.selectTableCell}>
                      <Box>
                        <KenSelect
                          name="faculty"
                          options={facultyDropDown}
                          value={facultyDrop.faculty}
                          dropdownColor="#ffffff"
                          onChange={(e) =>
                            setFacultyDrop({
                              ...facultyDrop,
                              [e.target.name]: e.target.value,
                            })
                          }
                          required={true}
                        />
                      </Box>
                    </TableCell> */}
                    <TableCell className={classes.selectTableCell}>
                      {row.isEditMode ? (
                        <>
                          <IconButton
                            aria-label="done"
                            onClick={() => onToggleEditMode('save', row.id)}
                          >
                            <DoneIcon />
                          </IconButton>
                          <IconButton
                            aria-label="revert"
                            onClick={() => onRevert(row.id)}
                          >
                            <RevertIcon />
                          </IconButton>
                        </>
                      ) : (
                        <IconButton
                          aria-label="delete"
                          onClick={() => onToggleEditMode('edit', row.id)}
                        >
                          <EditIcon />
                        </IconButton>
                      )}
                    </TableCell>
                    {row.button === 'assign' ? (
                      <TableCell className={classes.selectTableCell}>
                        <Box>
                          <div style={{ display: 'flex' }}>
                            <Button
                              variant="primary"
                              component={Link}
                              className={classes.normal}
                              to={`${routes.invigilationProctoring}/${row.id}`}
                            >
                              Assign
                            </Button>
                            <Button
                              variant="primary"
                              component={Link}
                              className={classes.publishGenerate}
                              // to={`${routes.currentProgrammes}/${id}/details`}
                            >
                              Publish
                            </Button>
                          </div>
                        </Box>
                      </TableCell>
                    ) : (
                      <TableCell className={classes.selectTableCell}>
                        <Box>
                          <div style={{ display: 'flex' }}>
                            <Button
                              variant="primary"
                              component={Link}
                              className={classes.Blue}
                              // to={`${routes.seatingPlan}/arrangement/${id}`}
                            >
                              View / Edit
                            </Button>
                            <Button
                              variant="primary"
                              component={Link}
                              className={classes.publishView}
                              // to={`${routes.currentProgrammes}/${id}/details`}
                            >
                              Publish
                            </Button>
                          </div>
                        </Box>
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </KenCard>
      </Box>

      {/* Filter Modal */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            FILTER
          </Typography>
        }
        icon={<RiCheckFill />}
        maxWidth={'md'}
        open={filterDialog}
        handleClose={() => handleFilterDialog()}
        negativeButtonClick={() => handleFilterDialog()}
        positiveButtonClick={() => getInvigilator_s1_DataListing()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Course"
              options={selectOptionsCampus}
              value={selectValueCampus}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeCampus}
              required
            />
          </Grid>

          {/* <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Subject"
              options={selectOptionsSubject}
              value={selectValueSubject}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeSubject}
              required
            />
          </Grid> */}
          {/* <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Batch"
              options={selectOptionsProgram}
              value={selectValueProgram}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeProgram}
              required
            />
          </Grid> */}
          <Grid item xs={12} sm={6}>
            <KenDateTimePicker
              label="Start Date"
              inputBaseRootClass={classes.kenDateTimePickerColor}
              placeholder="Start Date"
              value={endDate}
              type="date"
              required={true}
              defaultValue={endDate}
              onChange={manageStartDate}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Duration"
              options={selectOptionsDuration}
              value={selectValueDuration}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeDuration}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Exam Type"
              options={selectOptionsBatch}
              value={selectValueBatch}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeBatch}
              required
            />
          </Grid>
        </Grid>
      </KenDialogBox>

      {/* Message Modal */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Send Bulk Message
          </Typography>
        }
        open={sendBulkMessageDialog}
        handleClose={() => handleSendBulkMessageDialog()}
        negativeButtonClick={() => handleSendBulkMessageDialog()}
        positiveButtonClick={() => handleSendBulkMessageDialog()}
        positiveButtonText={<SendIcon />}
        negativeButtonText={<AttachFile />}
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Box className="cardlsitbox">
              <KenCard elevation={0}>
                <Kentable
                  data={sendBulkDataGrid}
                  initialState={{
                    hiddenColumns: ['id'],
                  }}
                  allcheckboxData={(state) => handleSelectAllRows(state)}
                  onRowCheckBox={(event, row, index) =>
                    handleSelectRow(event, row, index)
                  }
                />
              </KenCard>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box className="cardlsitbox">
              <KenCard elevation={0}>
                <TextField
                  placeholder="Add Comments"
                  multiline
                  rows={10}
                  maxRows={'Infinity'}
                />
              </KenCard>
            </Box>
          </Grid>
        </Grid>
      </KenDialogBox>
    </Box>
  );
};

export default Invigilation;
